import { createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("GET_NJORD_UTBETALINGSOVERSIKT"),
	...createNetworkActions("GET_UTBETALINGSOVERSIKT"),
};
